import { computed } from 'vue';


/**
 *  Since Vue 3 provides two different methods of handling
 *  globals, we provide both methods for the globals we
 *  use in our app. This greatly simplifies our implementatin
 *  of plubins, as they don't depned on a state store like
 *  Pinia, or anyhting else. We simply rely on built-in Vue
 *  functionality to `provide/inject` in the composition
 *  API and app.config.globalProperties if using the
 *  options API. `
 *
 *  Keep in min... our API is likely to change here
 *  in the early stages. So this file may be messy
 *  for a while.
 *
 *  Access in the options API with (ex: this.$config or this.$context)
 *  or in the composition API with `inject('appData'); then appData.config
 *  or appData.context`
 */

export function setupGlobalComputed ( app, clientConf, clientSidebarItems, clientContext ) {

  const context = computed(()=>clientContext);
  const config = computed(() => clientConf);
  const sidebarItems = computed(() => clientSidebarItems);
  // more to come
  //
  const appData = {
    context,
    config,
    sidebarItems,
    // more to come
  };
  app.provide('appData', appData);

  // proved eith global helpers
  Object.defineProperties(app.config.globalProperties, {
    $config: { get: () => config.value },
    $context: { get: () => context.value },
    $sidebarItems: {get: () => sidebarItems.value },
    // more to come...
  });

  return appData;

}
